<template>
  <form class="change-currency-form">
    <h4 class="form__title">
      {{ $t('CP.changeCurrency') }}
    </h4>
    <currency-list
      @changeCurrency="changeCurrency"
      :currencies="filteredCurrencies"
      :active-currency="currentCurrency"
    />
    <div class="form-buttons">
      <button-app
        class="form-button form-button_cancel"
        @clicked="$bvModal.hide('change-event-currency')"
        color-scheme="gray"
        type="button">
        {{ $t('CP.close') }}
      </button-app>
<!--      <button-app-->
<!--        class="form-button form-button_save"-->
<!--        color-scheme="blue"-->
<!--        @clicked="handleSubmit"-->
<!--        type="button"-->
<!--        :disabled="false"-->
<!--      >-->
<!--        {{ $t('CP.ready') }}-->
<!--      </button-app>-->
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';
import { FETCH_EVENT_REQUEST } from '@/store/events/types';
import ButtonApp from '../../components/Button/ButtonApp';
import CurrencyList from '../../components/CurrencyList/CurrencyList';

export default {
  name: 'ChangeEventCurrencyForm',
  components: {
    CurrencyList,
    ButtonApp,
  },
  data() {
    return {
      currentCurrency: '',
    };
  },
  mounted() {
    this.currentCurrency = this.eventCurrency || this.user.currency;
    if (this.eventIsOriginal) {
      this.currentCurrency = 'original';
    }
  },
  computed: {
    ...mapState({
      currencies: (state) => state.currency.currencies,
      user: (state) => state.user.user,
      event: (state) => state.events.event,
      eventCurrency: (state) => state.events.eventCurrency,
      eventIsOriginal: (state) => state.events.eventIsOriginal,
    }),
    filteredCurrencies() {
      return [
        {
          cur_description: this.$t('CP.noConvertation'),
          currency: 'original',
          id: this.currencies.length,
        },
        ...this.currencies
          .filter((currency) => this.event.used_currencies
            .findIndex((eventCurrency) => (eventCurrency === currency.currency
              || this.user.currency === currency.currency)) !== -1),
      ];
    },
  },
  methods: {
    changeCurrency(currency) {
      this.currentCurrency = currency;
      this.handleSubmit();
    },
    handleSubmit() {
      this.$store.dispatch(FETCH_EVENT_REQUEST, {
        id: this.event.id,
        currency: this.currentCurrency,
      });
      this.$bvModal.hide('change-event-currency');
    },
  },
};
</script>

<style lang="scss" scoped>
  .change-currency-form {
    color: var(--text-main-color);
  }
  .form-buttons {
    display: flex;
    flex: 1 0 50%;
    justify-content: center;
    margin: 22px 0 0 0;
  }
  .form-button {
    flex: 1;
    height: 38px;
    margin: 0;
  }
  .form-button_cancel {
    margin: 0 8px 0 0;
  }
  @media screen and (max-width: $breakpoint-sm) {
    .change-currency-form {
      padding-bottom: 60px;
    }
    .form-buttons {
      position: absolute;
      left: 32px;
      right: 32px;
      bottom: 32px;
    }
  }
</style>
